module.exports = __webpack_public_path__ + "img/32.652b4700.png";